import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_sidebar_item = _resolveComponent("sidebar-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'has-logo':_ctx.showLogo}),
    style: _normalizeStyle({ backgroundColor: _ctx.settings.sideTheme === 'theme-dark' ? _ctx.variables.menuBackground : _ctx.variables.menuLightBackground })
  }, [
    (_ctx.showLogo)
      ? (_openBlock(), _createBlock(_component_logo, {
          key: 0,
          collapse: _ctx.isCollapse
        }, null, 8, ["collapse"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_scrollbar, {
      class: _normalizeClass(_ctx.settings.sideTheme),
      "wrap-class": "scrollbar-wrapper"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          "default-active": _ctx.activeMenu,
          collapse: _ctx.isCollapse,
          "background-color": _ctx.settings.sideTheme === 'theme-dark' ? _ctx.variables.menuBackground : _ctx.variables.menuLightBackground,
          "text-color": _ctx.settings.sideTheme === 'theme-dark' ? _ctx.variables.menuColor : _ctx.variables.menuLightColor,
          "unique-opened": true,
          "active-text-color": _ctx.settings.theme,
          "collapse-transition": false,
          mode: "vertical"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sidebarRouters, (route, index) => {
              return (_openBlock(), _createBlock(_component_sidebar_item, {
                key: route.path  + index,
                item: route,
                "base-path": route.path
              }, null, 8, ["item", "base-path"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active", "collapse", "background-color", "text-color", "active-text-color"])
      ]),
      _: 1
    }, 8, ["class"])
  ], 6))
}